import React from "react";
import "../styles/About.css"; // Import the updated CSS
import OurApproach from "../components/OurApproach/OurApproach";
import AboutSection from "../components/AboutSection/About";
import WhyChooseUs from "../components/WhyChooseUs/WhyChooseUs";

const About = () => {
  return (
    <>
    <section className="banner_area">
      <div className="banner_inner d-flex align-items-center">
        <div className="overlay bg-parallax"></div>
        <div className="container">
          <div className="banner_content text-center">
            <h2>About Us</h2>
            <div className="page_link">
              <a href="/">Home</a>
              <span className="breadcrumb-arrow">→</span>
              <a href="/about">About Us</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <OurApproach/>
    <AboutSection/>
    <WhyChooseUs/>
    </>
  );
};

export default About;
